module.exports = __webpack_public_path__ + "static/img/far3_active.234ed495.png";